export default __webpack_public_path__ + "static/button_soundcloud-fb54baa6d6c6ae65277433c2950a90ba.png";